import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, RoughEase, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch6_p02 } from "../../../layouts/ch6_p02/ch6_p02";

export class Chapter6Page2 extends AbstractStoryState implements ReturnType<typeof ch6_p02> {

    readonly bg = this.addChild(new SceneSprite());
    readonly horse = this.addChild(new SceneSprite());
    readonly holly = this.addChild(new SceneSprite());
    readonly tyler = this.addChild(new SceneSprite());
    readonly tylerArm = this.addChild(new SceneSprite());
    readonly tylerPocketFront = this.addChild(new SceneSprite());
    readonly tylerRain = this.addChild(new SceneSprite());
    readonly gift = this.addChild(new SceneSprite());
    readonly rain = [this.addChild(SceneSprite.withPrefix("ch6_p02/")), this.addChild(SceneSprite.withPrefix("ch6_p02/"))];

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch6_p02/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch6_p02/"));
    readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch6_p02/"));
    readonly linesRight = this.addChild(SceneSprite.withPrefix("ch6_p02/"));

    protected armTimeline?: TimelineMax;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch6_p02.call(this);
        this.frameLeft.visible = false;
        this.frameRight.visible = false;

        this.gift.interactive = true;
        this.gift.buttonMode = true;
        this.gift.accessible = true;
        this.gift.addListener(HLF.Input.Events.POINTER_TAP, ()=>{
            this.armTimeline?.kill();
            this.gotoNextState({transition: "left"});
        });

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);

        new TimelineLite()
            .from(this.gift, 1.5, {pixi: {y: this.gift.y + 200}, ease: Expo.easeOut})
            .delay(3)
        ;
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
        const mainLoop = HLF.Application.instance.audio.getAudioTrack("HH_Ch5_Holly_Tyler_InRain_LoopC_P16-17", HLF.AudioCategory.BGM);
        mainLoop?.fadeTo(0, 1000);
    }

    public destroy() {
        super.destroy();
        this.armTimeline?.kill();
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        this.armTimeline = new TimelineMax();
        const fast = 0.1;
        const slow = 0.3;
        const down = 2.5;
        const up = 0;
		this.armTimeline
			.to(this.tylerArm, fast, {pixi: {
				angle: down,
			}})
            .to(this.tylerArm, fast, {pixi: {
				angle: up,
			}})
            .to(this.tylerArm, slow, {pixi: {
				angle: down,
			}})
            .to(this.tylerArm, fast, {pixi: {
				angle: up,
			}})
            .to(this.tylerArm, fast, {pixi: {
				angle: down,
			}})
            .to(this.tylerArm, slow, {pixi: {
				angle: up,
			}});
		this.armTimeline.repeat(-1).yoyo(false).repeatDelay(0);
    }
}